import { Calendar } from 'react-date-range';

import { useCalendarNavigator } from './CalendarNavigator';

import theme from '../../../themes/colors';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '@components/date-picker/styles.css';

interface CalendarV2Props {
  date: Date | null;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
}

const CalendarV2 = ({
  date,
  onChange,
  minDate,
  maxDate,
  className = ''
}: CalendarV2Props) => {
  const navigatorRenderer = useCalendarNavigator({ minDate, maxDate });

  // Default min and max dates if not provided in props
  const finalMinDate =
    minDate || new Date(new Date().getFullYear() - 100, 0, 1);
  const finalMaxDate =
    maxDate || new Date(new Date().getFullYear() + 10, 11, 31);

  return (
    <div
      className={`date-picker-v2 flex !h-105 justify-center rounded-xl border border-cofeeGreyBlue5 ${className}`}
    >
      <Calendar
        className="!bg-transparent !text-sm !text-content"
        date={date ?? new Date()}
        minDate={finalMinDate}
        maxDate={finalMaxDate}
        onChange={onChange}
        color={theme.primary}
        fixedHeight
        navigatorRenderer={navigatorRenderer}
      />
    </div>
  );
};

export default CalendarV2;
